import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Heart, Loader2 } from "lucide-react";
import { getPostLikes } from "@/lib/api";
import { useNavigate } from "react-router-dom";

export default function LikesDialog({ postId, open, onOpenChange }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open || !postId) return;
    setLoading(true);
    getPostLikes(postId)
      .then(res => setUsers(res.data.users || []))
      .catch(() => setUsers([]))
      .finally(() => setLoading(false));
  }, [open, postId]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-[#E5E0D5] max-w-sm" data-testid="likes-dialog">
        <DialogHeader>
          <DialogTitle className="font-['Crimson_Text'] text-lg text-[#2D2A26] flex items-center gap-2">
            <Heart className="w-5 h-5" style={{ color: "var(--liturgical-primary)" }} /> Liked by
          </DialogTitle>
        </DialogHeader>
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--liturgical-primary)" }} />
          </div>
        ) : users.length === 0 ? (
          <p className="text-center font-['Nunito'] text-sm text-[#6B665E] py-6">No likes yet</p>
        ) : (
          <ScrollArea className="max-h-72">
            <div className="space-y-1 py-1">
              {users.map(u => (
                <button
                  key={u.user_id}
                  onClick={() => { onOpenChange(false); navigate(`/profile/${u.user_id}`); }}
                  className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-[#F9F7F2] transition-colors text-left"
                  data-testid={`likes-user-${u.user_id}`}
                >
                  <div className="w-9 h-9 rounded-full bg-[#F0EBE0] flex items-center justify-center flex-shrink-0 overflow-hidden">
                    {u.profile_photo ? (
                      <img src={u.profile_photo} alt="" className="w-full h-full object-cover" />
                    ) : (
                      <span className="font-['Nunito'] text-sm font-bold text-[#6B665E]">{(u.name || "?")[0]}</span>
                    )}
                  </div>
                  <p className="font-['Nunito'] text-sm font-medium text-[#2D2A26] truncate">{u.name}</p>
                </button>
              ))}
            </div>
          </ScrollArea>
        )}
      </DialogContent>
    </Dialog>
  );
}
